module.exports = __webpack_public_path__ + "assets/img/mecha-btn-812f87dd.png";